import { Component, inject, OnDestroy } from '@angular/core';
import { SharedStorageService } from '@luggagehero/shared/services/storage';

import { BaseModalComponent } from '../../../core';
import { ModalService } from '../../../core/services/index';

@Component({
  template: '',
  standalone: false,
})
export abstract class CookieConsentBaseComponent extends BaseModalComponent implements OnDestroy {
  private storage = inject(SharedStorageService);
  private modal = inject(ModalService);

  public ngOnDestroy(): void {
    //
    // When the modal is closed, we consider consent given, regardless of whether the user clicked the accept button or
    // or closed the modal by clicking outside of it.
    //
    this.storage.isCookieConsentGiven = true;
  }

  public onAccept() {
    void this.modal.hide();
  }
}
